import * as ActionTypes from '../constants/ActionTypes';

const initialState = {
	loading: false,
	total: 0,
	point_of_interest_types_total: 0,
	buildings: null,
	locations: null,
	point_of_interest_types: null,
	all_base_map: null,
	filteredLocations: null,
	point_of_interests: null,
	panorama_nodes: null,
	panorama_nodes_building_floor_id: null,
	loading_panorama_nodes: false,
	panorama_node: null,
	panorama_edges: null,
	loadingLocType: false
};

export default function mapPageReducer(state = initialState, action) {
	switch (action.type) {
		case ActionTypes.GET_BUILDINGS_REQUEST:
		case ActionTypes.GET_BUILDINGS_ERROR:
		case ActionTypes.GET_BUILDINGS_SUCCESS:
		case ActionTypes.GET_LOCATIONS_REQUEST:
		case ActionTypes.GET_LOCATIONS_ERROR:
		case ActionTypes.GET_LOCATIONS_SUCCESS:
		case ActionTypes.GET_LOCATIONS_BY_TYPE_REQUEST:
		case ActionTypes.GET_LOCATIONS_BY_TYPE_ERROR:
		case ActionTypes.GET_LOCATIONS_BY_TYPE_SUCCESS:
		case ActionTypes.GET_LOCATIONS_POINT_OF_INTEREST_TYPES_REQUEST:
		case ActionTypes.GET_LOCATIONS_POINT_OF_INTEREST_TYPES_ERROR:
		case ActionTypes.GET_LOCATIONS_POINT_OF_INTEREST_TYPES_SUCCESS:
		case ActionTypes.GET_ALL_BASE_MAP_REQUEST:
		case ActionTypes.GET_ALL_BASE_MAP_ERROR:
		case ActionTypes.GET_ALL_BASE_MAP_SUCCESS:
		case ActionTypes.GET_POINT_OF_INTERESTS_REQUEST:
		case ActionTypes.GET_POINT_OF_INTERESTS_ERROR:
		case ActionTypes.GET_POINT_OF_INTERESTS_SUCCESS:
		case ActionTypes.GET_PANORAMA_NODES_REQUEST:
		case ActionTypes.GET_PANORAMA_NODES_ERROR:
		case ActionTypes.GET_PANORAMA_NODES_SUCCESS:
		case ActionTypes.GET_PANORAMA_NODE_BY_ID_REQUEST:
		case ActionTypes.GET_PANORAMA_NODE_BY_ID_ERROR:
		case ActionTypes.GET_PANORAMA_NODE_BY_ID_SUCCESS:
		case ActionTypes.GET_PANORAMA_EDGES_REQUEST:
		case ActionTypes.GET_PANORAMA_EDGES_ERROR:
		case ActionTypes.GET_PANORAMA_EDGES_SUCCESS:
			return {
				...state,
				...action.payload
			};
		case ActionTypes.RESET_LOCATIONS_META:
			return {
				...state,
				meta: null
			};
		case ActionTypes.RESET_LOCATIONS_PAGE:
			return {
				...initialState
			};
		default:
			return state;
	}
}
